<template>
    <el-row :gutter="30" class="mw-100">
        <el-col :lg="24" :xs="24">
            
            <el-card class="box-card">
                <el-table :data="coveragePhotos" style="width: 100%">
                    
                    
                    
                    <el-table-column label="image" prop="imageURL" width="80" >
                        <template #default="scope">
                            <el-image 
                                style="width: 50px; height: 50px" 
                                :src="$getImage(scope.row.imageURL) || ''" 
                                fit="cover"
                                :zoom-rate="1.2"
                                :preview-src-list="[$getImage(scope.row.imageURL)]"
                                :preview-teleported="true"
                            >
                                <template #error>
                                    <div class="image-slot">
                                        <font-awesome-icon :icon="['fas', 'image']" />
                                    </div>
                                </template>
                            </el-image>
                        </template>
                    </el-table-column>
                    
                    <el-table-column label="Language" >
                        <template #default="scope">
                           {{$getLanguageName(scope.row.languageID)}}
                        </template>
                    </el-table-column>
                    
                    
                    <el-table-column label="Operations" width="100">
                        <template #default="scope">
                            <el-tooltip
                                class="box-item"
                                effect="dark"
                                content="edit product"
                                placement="top"
                            >
                                <font-awesome-icon :icon="['fas', 'edit']" style="width:20px" @click="handleEditCoveragePhoto(scope.row)" class="cursor-pointer" />
                            </el-tooltip>
                             
                                
                        </template>
                    </el-table-column>
                </el-table>
               
            </el-card>
        </el-col>
    </el-row>
 
</template>
<script>
export default {
    computed:{
        cachedCoveragePhotos(){
            return JSON.parse(localStorage.getItem('adminStore'))?.website.coveragePhotos?.list || []
        },
    },
    data(){
        return{
            coveragePhotos:[],
            coveragePhotoStatus:[],
           
        }
    },
    async mounted(){
        if (!this.cachedCoveragePhotos?.length){
            this.getAllCoveragePhotos();
        }else{
            this.coveragePhotos = this.cachedCoveragePhotos;
          
        }
        
       
    },
    
    methods:{
       
        async getAllCoveragePhotos(){
            const response = await this.$store.dispatch('getAllCoveragePhotos');

            this.coveragePhotos = response;
             
        },
        async changeCoveragePhotoStatus(coveragePhoto){
            const response = await this.$store.dispatch('changeCoveragePhotoStatus',coveragePhoto.id);
            if (response.data.status == 1){
         
                this.getAllCoveragePhotos();
                this.$notify({
                    title:String(response.status),
                    message:response.data.message,
                    type:'success',
                });
            }else{
                let currentCoveragePhotoIndex = this.coveragePhotos.findIndex(prt => prt.id == coveragePhoto.id);
                this.coveragePhotos[currentCoveragePhotoIndex].active = !this.coveragePhotos[currentCoveragePhotoIndex].active 
                // this.coveragePhotos.splice(currentCoveragePhotoIndex,1);
            }
             
        },
        async handleAddCoveragePhoto(){
            this.$router.push({
                name:'manage-photo',
            })
           
        },
        async handleEditCoveragePhoto(coveragePhoto){
            await this.$store.dispatch('storeCurrentCoveragePhotoToView',coveragePhoto)
            this.$router.push({
                name:'manage-photo',
                params:{
                    id:coveragePhoto.languageID
                }
            })
        },
      
    
       
        
    }
}
</script>
<style lang="scss">
    .text-right.rtl {
        .cell {
            text-align: right;
            direction: rtl;
        }
    }
</style>